import { Box, freddyTheme, VideoContainer } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';

import { COVER_WIDTH, VIDEO_CARD_MOBILE_HEIGHT } from './';

export const VideoCard = ({ videoId }: { videoId: string | undefined }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: VIDEO_CARD_MOBILE_HEIGHT,
        overflow: 'hidden',
        width: '100%',
        [freddyTheme.breakpoint.minWidth('lg')]: {
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100vh'
        }
      }}
    >
      {videoId ? (
        <>
          <VideoContainer
            videoId={videoId}
            title='Home Page background video'
            autoPlay
            loop
            mute
            hideControls
            sx={{
              position: 'absolute',
              pointerEvents: 'none',

              // it makes sure that youtube video covers the entire container
              '& iframe': {
                top: '50%',
                left: '50%',
                minWidth: COVER_WIDTH,
                transform: 'translate(-50%, -50%)'
              }
            }}
          />

          {/* Dimmed overlay */}
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              pointerEvents: 'none',
              backgroundColor: freddyTheme.color.background.backdropDimmed
            }}
          />
        </>
      ) : (
        <Image
          imageId='599288'
          fileCollection='content'
          fullWidth
          width={4000}
          height={1000}
          objectFit='cover'
          alt='HeroSection background'
          loading='eager'
        />
      )}
    </Box>
  );
};
